
import { Component, Vue } from 'vue-property-decorator'
import IconBox from '@/components/container/IconBox.vue'
import { IconDataSpan } from 'ui-library'
import i18n from '@/i18n'

@Component({
  i18n,
  components: {
    IconBox
  }
})
export default class PersonalDataIconBox extends Vue {
  private changeNameURL: string = window.ENV_CONFIG.SERVICE_LINKS.PERSONAL_PAGE.CHANGE_NAME_PAGE
  private changeAddressURL: string = window.ENV_CONFIG.SERVICE_LINKS.PERSONAL_PAGE.CHANGE_ADDRESS_PAGE
  private changeBankDataURL: string = window.ENV_CONFIG.SERVICE_LINKS.PERSONAL_PAGE.CHANGE_BANKDATA_PAGE

  get personalDataIconList(): IconDataSpan[] {
    const changeNameIcon: IconDataSpan = {
      href: this.changeNameURL,
      iconClass: 'name',
      label: this.$t('personalDataIcons.changeName').toString(),
      isRouterLink: true
    }

    const changeAddressIcon: IconDataSpan = {
      href: this.changeAddressURL,
      iconClass: 'adresse',
      label: this.$t('personalDataIcons.changeAddress').toString(),
      isRouterLink: true
    }

    const changeBankDataIcon: IconDataSpan = {
      href: this.changeBankDataURL,
      iconClass: 'bankdaten',
      label: this.$t('personalDataIcons.changeBankData').toString(),
      isRouterLink: true
    }

    return [changeNameIcon, changeAddressIcon, changeBankDataIcon]
  }
}
